<template>
    <div id="app">
        <div class="container-fluid">
            <div class="row" v-if="requiresAuthentication">
                <div class="col logo-header">
                    <router-link to="/">
                        <img src="./assets/images/logo.png" width="111px">
                    </router-link>
                </div>
            </div>
            <div v-if="requiresAuthentication" class="row">
                <div class="col menu-slot">
                    <menu-component></menu-component>
                </div>
            </div>
            <div class="row">
                <div class="col main-content">
                    <router-view>
                    </router-view>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <footer-component v-if="requiresAuthentication"></footer-component>
                </div>
            </div>
            <vue-cookie
                :debug="false"
                :position="'bottom'"
                :disableDecline="false"
                :transitionName="'slideFromBottom'"
                @status="cookieStatus"
                @clickedAccept="cookieClickedAccept"
                @clickedDecline="cookieClickedDecline">
                <div slot="message">
                    OMyFu speichert personenbezogene Daten. Bist du damit einverstanden? <a href="http://www.omyfu.com/disclaimer" target="_blank">Mehr erfahren...</a>
                </div>
                <div slot="declineContent">
                    Ablehnen
                </div>
                <div slot="acceptContent">
                    Einverstanden
                </div>
            </vue-cookie>
        </div>
    </div>
</template>

<script>
    import MenuComponent from './components/MenuComponent.vue'
    import FooterComponent from './components/FooterComponent'
    import {mapState} from 'vuex'
    import VueCookieAcceptDecline from 'vue-cookie-accept-decline'

    export default {
        name: 'App',
        metaInfo: {
            title: 'Home',
            titleTemplate: 'OMyFu | %s'
        },
        components: {
            'menu-component': MenuComponent,
            'footer-component': FooterComponent,
            'vue-cookie': VueCookieAcceptDecline
        },
        computed: {
            requiresAuthentication () {
                if (this.$route.meta.requiresAuth == null) {
                    return false
                } else {
                    return this.$route.meta.requiresAuth
                }
            },
            ...mapState({
                location: state => state.route.path
            })
        },
        methods: {
            cookieStatus: function (e) {
                // console.log('status')
                // console.log(e)
            },
            cookieClickedAccept: function () {
                // console.log('accepted')
            },
            cookieClickedDecline: function () {
                // console.log('declined')
            }
        },
        created () {
        }
    }
</script>

<style lang="scss">
    @import './assets/scss/custom';

    #app {
        font-family: 'roboto-regular', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: $omyfu-font-color;
        margin-top: 25px;
    }

    .logo-header {
        padding-bottom: 25px;
    }

    @font-face {
        font-family: 'roboto-regular';
        src: url('./assets/fonts/roboto/roboto-regular.woff2') format('woff2'),
        url('./assets/fonts/roboto/roboto-regular.woff') format('woff');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'alfa-regular';
        src: url('./assets/fonts/alfa/alfaslabone-regular.woff2') format('woff2'),
        url('./assets/fonts/alfa/alfaslabone-regular.woff') format('woff');
        font-weight: normal;
        font-style: normal;
    }

    .main-content {
        padding-bottom: 80px;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue